import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Table, Box, Button } from '@mui/material/';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";


import { useCallback, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Logo from '../../../Media/Upload.jpeg';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F2F4F7",
    color: "#667085",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));



const rows = [
  {
    "DocumentName": "Form_pdf_166980070180721 (1).pdf",
    "UploadedOn": "12/02/2021"
  },
  {
    "DocumentName": "Form_pdf_166980070180721 (1).pdf",
    "UploadedOn": "12/02/2021"
  },
  {
    "DocumentName": "Form_pdf_166980070180721 (1).pdf",
    "UploadedOn": "12/02/2021"
  },
  {
    "DocumentName": "Form_pdf_166980070180721 (1).pdf",
    "UploadedOn": "12/02/2021"
  }

];


export default function EmployeeDocument() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [open1, setOpen1] = React.useState(false);

  const handleClickOpen1 = () => {
    setOpen1(true);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);

  const activeStyle = {
    borderColor: '#2196f3'
  };

  const acceptStyle = {
    borderColor: '#00e676'
  };

  const rejectStyle = {
    borderColor: '#ff1744'
  };
  const onDrop = useCallback(acceptedFiles => {
    setFiles(acceptedFiles?.map(file => Object.assign(file, {
      preview: URL.createObjectURL(file)
    })));
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop,
    accept: 'image/jpeg, image/png'
  });

  const style = useMemo(() => ({

    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const thumbs = files?.map(file => (
    <div key={file?.name}>
      {file?.name}
    </div>
  ));
  // clean up
  useEffect(() => () => {
    files?.forEach(file => URL.revokeObjectURL(file?.name));
  }, [files]);
  const [open2, setOpen2] = React.useState(false);

  const handleClickOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  return (
    <>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "416px",  // Set your width here
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {"Upload Documents"}
        </DialogTitle>
        <DialogContent>
          <div className="drop" {...getRootProps({ style })} >
            <input {...getInputProps()} />
            <span className='text-muted mt-2 fs ' style={{ padding: "20px" }}><b><span className='mx-1 cl'>Click to upload</span>
              or drag and drop</b></span>
            <br />
            <span className=' text-muted Fs'> {thumbs}</span>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="login-help__buttonContainer ">
            <Button variant="contained" className="login-help-button-cancel" onClick={handleClose} >Cancel</Button>
            <Button variant="contained" className="login-button-request" onClick={handleClose} sx={{ marginLeft: "13px" }}>Save</Button>
          </div>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open1}
        onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "416px",  // Set your width here
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {"Replace the Document"}
        </DialogTitle>
        <DialogContent>
          <div className="drop" {...getRootProps({ style })} >
            <input {...getInputProps()} />
            <span className='text-muted mt-2 fs ' style={{ padding: "20px" }}><b><span className='mx-1 cl'>Click to upload</span>
              or drag and drop</b></span>
            <br />
            <span className=' text-muted Fs'> {thumbs}</span>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="login-help__buttonContainer ">
            <Button variant="contained" className="login-help-button-cancel" onClick={handleClose1} >Cancel</Button>
            <Button variant="contained" className="login-button-request" onClick={handleClose1} sx={{ marginLeft: "13px" }}>Save</Button>
          </div>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This operation can't be rolled back.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="login-help__buttonContainer ">
            <Button variant="outlined" onClick={handleClose2} >Cancel</Button>
            <Button variant="contained" onClick={handleClose2} sx={{ marginLeft: "13px" }}>Yes, delete</Button>
          </div>
        </DialogActions>
      </Dialog>
      <Box sx={{ padding: "10px", backgroundColor: "#fff" }}>
        <span style={{ fontSize: "18px", fontWeight: "600", color: "#101828", marginLeft: "5px" }}>
          Documents
        </span>

        <Button variant="contained" size="medium" sx={{ float: "right" }} onClick={handleClickOpen}>
          <SaveAltIcon sx={{ marginRight: "5px" }} /> Upload Documents

        </Button>

        <Button></Button>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ width: "1020px" }}>Document Name</StyledTableCell>
                <StyledTableCell align="right">Uploaded On</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
                <StyledTableCell align="right">&nbsp;</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell sx={{ color: "#2A93DB", cursor: "pointer" }} >
                    <InsertDriveFileOutlinedIcon /> {row?.DocumentName}
                  </StyledTableCell>
                  <StyledTableCell align="right">{row?.UploadedOn}</StyledTableCell>
                  <StyledTableCell align="right" sx={{ color: "#667085", }}><FileUploadOutlinedIcon sx={{ cursor: "pointer" }} onClick={handleClickOpen1} /></StyledTableCell>
                  <StyledTableCell align="right" sx={{ color: "#667085" }}><DeleteOutlineOutlinedIcon sx={{ cursor: "pointer" }} onClick={handleClickOpen2} /></StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  )
}
